import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";
import { statementsService } from "./statementsService";

type IStatementResponse =
  bankingApiSpec.operations["retrieveInternalAccountStatement"]["responses"]["200"]["content"]["application/json"];

export const getStatement = async (
  statementId: string
): Promise<IStatementResponse> => {
  const { data } = await statementsService.get(
    `/internal-account-statements/${statementId}`
  );

  return data;
};
